/* eslint-disable */
import "../App.css";
import React from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";

const Rules = () => {
  return (
    <>
      <Container>
        <Card className="m15">
          <Card.Body>
            <Card.Title>General Rules</Card.Title>
              <ol>
                <li>"A Beer" = A schooner of any alcoholic drink poured from a tap, OR a glass of wine.</li>
                <li>"A Drink" = Anything alcoholic</li>
                <li>Challenges can't be skipped unless otherwise noted (e.g. can't get Birdie without achieving Par)</li>
                <li>Use of performance-enhancing drugs is banned whilst competing</li>
                <li>Competition ends either at midnight, or if we leave the final hole</li>
                <li>A "Double Bogey, Don't attend pub" means no attempt was made to attend the pub. Getting denied entry does not count as a Double Bogey</li>
              </ol>
            <Card.Title>Shit Banta Clause</Card.Title>
            <p>
              Ambiguous phrasing of rules is resolved through common sense
              analysis. The "Shit Banta Clause" penalizes players who interpret
              rules differently to the majority with two extra strokes.
              Misinterpretation of the Shit Banta Clause itself is not exempt
              from penalty.
            </p>
            <Card.Title>Note</Card.Title>
            <p>Scores for de/merits will not be added until you have scored the pub</p>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default Rules;
